function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.038 9.08a.995.995 0 01-1.414 0 1 1 0 010-1.413l1.68-1.68H1.979a1 1 0 110-2.001h6.262L6.624 2.369A1 1 0 018.038.955l3.907 4.063L8.038 9.08z"
});

var SvgRightArrow = function SvgRightArrow(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEyIDEwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC4wMzggOS4wOGEuOTk1Ljk5NSAwIDAgMS0xLjQxNCAwIDEgMSAwIDAgMSAwLTEuNDEzbDEuNjgtMS42OEgxLjk3OWExIDEgMCAxIDEgMC0yLjAwMWg2LjI2Mkw2LjYyNCAyLjM2OUExIDEgMCAwIDEgOC4wMzguOTU1bDMuOTA3IDQuMDYzTDguMDM4IDkuMDh6Ii8+Cjwvc3ZnPgo=";
export { SvgRightArrow as ReactComponent };